// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"login_loginForm__bb99_","title":"login_title__2NweX","buttonsWrap":"login_buttonsWrap__LaUbR","wrapper":"login_wrapper__sqfDE"};